import { styled } from "@mui/material";

export const ListTable = styled("table")`
  width: 100%;
  border-collapse: collapse;
  outline: none !important;

  ${(props) => props.theme.breakpoints.up("lg")} {
    background: ${(props) => props.theme.palette.common.white};
    table-layout: fixed;

    thead tr:not(:first-of-type) {
      background: ${(props) => props.theme.palette.gray.background};

      td {
        padding: ${(props) => props.theme.spacing(1)};
      }
    }
  }
`;
